import React from "react";
import { useTranslation } from "react-i18next";
const GreyNoiseFullIPAdapterSummary = () => {
  const { t } = useTranslation("enterprise_integrations");
  return /* @__PURE__ */ React.createElement("dl", null, /* @__PURE__ */ React.createElement("dt", null, t("greynoise.fields.api_token")), /* @__PURE__ */ React.createElement("dd", null, "******"));
};
export default GreyNoiseFullIPAdapterSummary;
